import { render, staticRenderFns } from "./sousuo.vue?vue&type=template&id=dd541e26&scoped=true"
import script from "./sousuo.vue?vue&type=script&lang=js"
export * from "./sousuo.vue?vue&type=script&lang=js"
import style0 from "./sousuo.vue?vue&type=style&index=0&id=dd541e26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd541e26",
  null
  
)

export default component.exports